export const FETCH_START = 'search/FETCH_START'
export const FETCH_SUCCESS = 'search/FETCH_SUCCESS'
export const FETCH_FAILURE = 'search/FETCH_FAILURE'

export const SELECT_RESULTS = 'search/SELECT_RESULTS'
export const CLEAR_SELECTION = 'search/CLEAR_SELECTION'

export const HOVER_RESULT_START = 'search/HOVER_RESULT_START'
export const HOVER_RESULT_END = 'search/HOVER_RESULT_END'
